module.exports = __webpack_public_path__ + "static/media/bank_1.f41edb1c.png";